import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import { Auth, I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  formControl: {
    margin: theme.spacing.unit,
    display: "block",
  },
});

class EditPassword extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      passStr: {},
      crErrorStr: '',
      newErrorStr: '',
      reErrorStr: '',
      updateStr: '',
      isDisabled: true,
      passState: {
        isNumOk: false,
        isLowerOk: false,
        isUpperOk: false,
        isOverOk: false,
      }
    };
    this.style = {
      num: false,
      lower: false,
      upper: false,
      isOver: false
    };

    this.tmpStr = {
      currentpass : '',
      newpass : '',
      reenterpass : '',
    };
  }
  checkUser() {
    const that = this;
    return Auth.currentAuthenticatedUser().then(user => {
      if (!that._isMounted) { return; }
      Auth.userAttributes(user).then((attrRet) => {
        // ログイン済みで正しくトークンが生きている
        this.props.updateHeader('userProf');
        return;
      }).catch((attrErr) => {
        // トークンが死んでいる可能性がある
        Auth.signOut().then(() => {
          window.history.pushState("", "", "/");
          this.props.authStateChange('signIn');
        });
      });
    }).catch(err => {
      if (!that._isMounted) { return; }
      Auth.signOut().then(() => {
        window.history.pushState("", "", "/");
        this.props.authStateChange('signIn');
      });
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
  }

  handleChange = name => event => {
    let errorStr = '';
    let isDisabled = this.state.isDisabled;
    this.tmpStr[name] = event.target.value;
    if (name === 'reenterpass' &&
      this.tmpStr['newpass'] !== this.tmpStr['reenterpass']) {
      errorStr = I18n.get('The new password and input contents are different');
    }

    if (name !== 'currentpass') {
      if (this.checkPass(name, event.target.value) &&
        this.tmpStr['newpass'] === this.tmpStr['reenterpass']) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    }
    this.updateState(this.tmpStr, errorStr, isDisabled);
  }
  checkPass = (name, value) => {
    // PW評価器
    let myState = this.state.passState;
    myState.isNumOk = value.match(/[0-9]+/) ? true : false;
    myState.isLowerOk = value.match(/([a-z])+/) ? true : false;
    myState.isUpperOk = value.match(/([A-Z])+/) ? true : false;
    myState.isOverOk = !(value.length < 8);

    if (name === 'newpass') {
      this.style.num = myState.isNumOk;
      this.style.lower = myState.isLowerOk;
      this.style.upper = myState.isUpperOk;
      this.style.isOver = myState.isOverOk;
    }

    // エラーの有無をreturn
    return (myState.isNumOk && myState.isLowerOk && myState.isUpperOk && myState.isOverOk);
  }
  updateState = (passStr, errorStr, isDisabled) => {
    this.setState({
      isDisabled : isDisabled,
      passStr: passStr,
      crErrorStr: '',
      newErrorStr: '',
      reErrorStr: errorStr,
    });
  }
  update = () => {
    this.checkUser();
    if (this.tmpStr['currentpass'] === '') {
      const tmpErrorStr = I18n.get('The current password is not entered');
      this.setState({crErrorStr: tmpErrorStr});
      return;
    }
    Auth.currentAuthenticatedUser().then(result => {
      Auth.changePassword(result, this.state.passStr.currentpass, this.state.passStr.newpass).then(data => {
        const resultStr = data === "SUCCESS" ? 'Your password is updated.' : data;
        this.setState({
          updateStr:resultStr
        });
      }).catch(err => {
        this.handleError(err.message);
      });
    });
  }
  back = () => {
    this.props.history.push('/')
  }
  handleError = (message) => {
    let errMessage = '';
    let crPassError = '';
    let newPassError = '';
    const regexp = /'(.*?)'/g;
    let match;
    while ((match = regexp.exec(message)) !== null) {
      if (match[1] === 'previousPassword') {
        crPassError = I18n.get('Incorrect current password');
      }
      if (match[1] === 'proposedPassword') {
        newPassError = I18n.get('Incorrect new password');
      }
    }
    if (message === 'Attempt limit exceeded, please try after some time.') {
      errMessage = message;
    } else if (message === 'Incorrect username or password.') {
      crPassError = I18n.get('Incorrect current password');
    }
    this.setState({
      updateStr: errMessage,
      crErrorStr: crPassError,
      newErrorStr: newPassError
    });
  }
  showUpdateMessage = (text) => {
    if (text === 'Your password is updated.') {
      return (
        <Typography className="mypageUpdateText">{I18n.get(text)}</Typography>
      );
    } else {
      return (
        <Typography className="mypageErrorText editPass">{I18n.get(text)}</Typography>
      );
    }
  }
  render() {
    const { classes } = this.props;
    const currentPassError = this.state.crErrorStr !== '' ?
      <FormHelperText className="mypageErrorText" id="currentpass-helper-text">{this.state.crErrorStr}</FormHelperText> : null;
    const newPassError = this.state.newErrorStr !== '' ?
      <FormHelperText className="mypageErrorText" id="newpass-helper-text">{this.state.newErrorStr}</FormHelperText> : null;
    return (
      <div className="mypageContainer" >
        <div className={classes.container}>
          <div className="mypageBreadcrumbs">
            <Link to="/">{I18n.get('User profile')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;{I18n.get('Edit password')}
          </div>
          <p className="mypageTitle"><span class="mypageTitleIcon"></span>{I18n.get('Edit password')}</p>
          <div className="mypageUserinfoItem">
           <dl className="mypageInputFlex">
              <dt><Typography>{I18n.get('Current password')}</Typography></dt>
              <dd>
                <FormControl className={classes.formControl}>
                  <input className="mypageInputStyle" id="currentpass" type="password" placeholder={I18n.get('Current password')} onChange={this.handleChange('currentpass')} />
                  {currentPassError}
                </FormControl>
              </dd>
            </dl>
            <dl className="mypageInputFlex">
              <dt><Typography>{I18n.get('New Password')}</Typography></dt>
              <dd>
                <FormControl className={classes.formControl}>
                  <input className="mypageInputStyle" id="newpass" type="password" placeholder={I18n.get('New Password')} onChange={this.handleChange('newpass')} />
                  {newPassError}
                </FormControl>
              </dd>
            </dl>
            <dl className="mypageInputFlex">
              <dt><Typography>{I18n.get('Retype new password')}</Typography></dt>
              <dd>
                <FormControl className={classes.formControl}>
                  <input className="mypageInputStyle" id="reenterpass" type="password" placeholder={I18n.get('Retype new password')} onChange={this.handleChange('reenterpass')} />
                  <FormHelperText className="mypageErrorText" id="reenterpass-helper-text">{this.state.reErrorStr}</FormHelperText>
                </FormControl>
              </dd>
            </dl>
            <div className="mypagePassConditions">
              <p>{I18n.get('Password strength is required belows')}：</p>
              <ul>
                <li className={this.style.num ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require numbers')}</li>
                <li className={this.style.lower ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require lowercase letters')}</li>
                <li className={this.style.upper ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('Require uppercase letters')}</li>
                <li className={this.style.isOver ? 'validCheckImg' : 'notValidCheckImg'}>{I18n.get('8 letters more over')}</li>
              </ul>
            </div>
            <div>
              {this.showUpdateMessage(this.state.updateStr)}
            </div>
            <Button className="mypageLargeButton editPass" onClick={this.update} variant="contained" disabled={this.state.isDisabled}>
              {I18n.get('Save')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(EditPassword);
